var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48412 8.90731C9.82208 8.56936 10.37 8.56936 10.708 8.90731C11.0459 9.24527 11.0459 9.7932 10.708 10.1312L6.09257 14.7465C5.75462 15.0845 5.20669 15.0845 4.86873 14.7465L0.253348 10.1311C-0.0846057 9.7932 -0.0846057 9.24526 0.253348 8.90731C0.591302 8.56936 1.13923 8.56936 1.47719 8.90731L4.61527 12.0454L4.61527 0.865385C4.61527 0.387446 5.00272 -5.20927e-07 5.48066 -4.79144e-07C5.9586 -4.37361e-07 6.34604 0.387446 6.34604 0.865385L6.34604 12.0454L9.48412 8.90731Z",
    fill: "#F63E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1a6a41f77aa9acaac80559d6e784f230.svg";
export { ForwardRef as ReactComponent };